import { Select } from "antd";
import React, { useContext } from "react";
import { AppContext } from "../../../context/AppContext";
import useHttp from "../../../hooks/useHttp";
import { useVoiceContext } from "../../context/VoiceContext";
import { handleStatusChange, voiceAgentStatus } from "../../utils/VoiceUtils";
import HNotification from "../../../components/custom/notification/HNotification";

const WebOrPhoneModeSelectComponent = (props) => {
  const [callProperties, setCallProperties] = useVoiceContext();
  let { classNameProps, expandIcon, setShowOfflineMessageWhileInit, voiceIntegId, isFromHeader, restrictAccess } = props;
  const { fetchData } = useHttp();
  const [appProperties] = useContext(AppContext);

  const handleOnlineMode = (mode) => {
    let leftServiceId = appProperties?.leftServiceId;
    handleStatusChange(
      callProperties?.agentStatusValue,
      mode,
      leftServiceId,
      appProperties,
      voiceIntegId,
      fetchData,
      setCallProperties,
      setShowOfflineMessageWhileInit
    ).then(function (res) {
      console.log("res : handleOnlineMode : handleStatusChange >>>>", res);
      const statusValue = res?.data?.voiceAgentStatusEntity?.voiceAgentStatus;
      const errorMessage = res?.data?.errorMessage;
      if (errorMessage !== undefined) {
        if (errorMessage === "CALL_FORWARDING_NOT_ENABLED") {
          HNotification.notify({
            type: "error",
            message: "Call Forwarding Not Enabled",
            description: "Call forwarding is not enabled for your account. Kindly reach out to your administrator for assistance.",
            duration: 15,
          });
        } else if (errorMessage === "CALL_FORWARDING_NUMBER_NOT_FOUND") {
          HNotification.notify({
            type: "error",
            message: "No phone number available",
            description:
              "Call forwarding number has not been configured for your account yet. Kindly reach out to your administrator for assistance.",
            duration: 15,
          });
        }
      } else {
        if (statusValue === voiceAgentStatus.ONLINE_WEB) {
          setShowOfflineMessageWhileInit(false);
          setCallProperties((prev) => ({
            ...prev,
            focusToNumberField: "visible",
          }));
        } else {
          setCallProperties((prev) => ({
            ...prev,
            focusToNumberField: "hidden",
          }));
        }
      }
    });
  };

  return (
    <div className={`${classNameProps} w-100`}>
      <Select
        defaultValue={1}
        value={callProperties?.agentVoiceMode}
        popupClassName={isFromHeader ? "dialpadSelectList-header" : "dialpadSelectList"}
        rootClassName={`cursor-pointer ${isFromHeader ? "dialpadSelectList-header" : "dialpadSelectList"}`}
        suffixIcon={<div className={`${expandIcon} call-action-icons `} />}
        options={[
          {
            value: 1,
            label: (
              <div className={`p-1 d-flex flex-row align-items-center ${isFromHeader ? "" : "hs-color-white"}`}>
                <div className={`call-action-icons ${isFromHeader ? "over-the-web-icon" : "over-the-web-white-icon"}`}></div>
               <div className="hs-ps-1-5">Over the web</div>
              </div>
            ),
          },
          {
            value: 2,
            label: (
              <div className={`p-1 d-flex flex-row align-items-center ${isFromHeader ? "" : "hs-color-white"}`}>
                <div className={`call-action-icons ${isFromHeader ? "over-the-phone-icon" : "over-the-phone-white-icon"}`}></div>
                <div className="hs-ps-1-5">Over the phone</div>
              </div>
            ),
          },
        ]}
        disabled={callProperties?.disableAgentStatusChange || restrictAccess}
        onChange={handleOnlineMode}
      />
    </div>
  );
};

export default WebOrPhoneModeSelectComponent;
